import { css } from '@/styled-system/css';

export const thumbnailSizeStyles = css.raw({
  height: '56px',
  width: '56px',
});

export const thumbnailBorderRadius = css.raw({
  borderRadius: '300',
});

export const thumbnailBackgroundStyles = css.raw({
  backgroundColor: 'bg.softest',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  padding: 'tight',
});
